import * as XLSX from 'xlsx';
import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
// @ts-ignore
import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { FormsModule } from '@angular/forms';
import { Subscription, firstValueFrom, forkJoin } from 'rxjs';
import { ImpressaoCompraSelecao, MODELOS_COMPRA } from '../compra-impressao/compra-impressao.model';
import { SankhyaGatewayService } from '../../services/sankhya-gateway.service';
import { EmpresaStateService } from '../../services/empresa-state.service';

interface PedidoCompraLinha {
  nunota:       number;
  codemp:       number;
  dtmov:        string;
  fornecedor:   string;
  docparc:      string;
  empresa:      string;
  vlrnota:      number;
  vlrmoeda:     number;
  vlritens:     number;
  vlritensMoe:  number;
  vlripi:       number;
  vlrst:        number;
  vlrcoreusd:   number;
  status:       string;
  comprador:    string;
  tipoOperacao: string;
  /** PCR_ID do pedido no Aerosys (TGFCAB.GPL_PCRIDAEROSYS); vazio quando não há vínculo. */
  pcrIdAerosys: number | null;
  codTipOper:   number;
  observacao:   string;
  gplStatus:    string;
  numTitulo:    string;
  prioridade:   string;
  tipoGpl:      string;
}

// @ts-ignore
@Component({
  selector: 'app-pedido-compra',
  standalone: true,
  imports: [LoadingIndicatorComponent, CommonModule, FormsModule],
  templateUrl: './pedido-compra.component.html',
  styleUrls: ['./pedido-compra.component.css']
})
export class PedidoCompraComponent implements OnInit, OnDestroy {

  @Output() novoPedido   = new EventEmitter<void>();
  @Output() editarPedido = new EventEmitter<number>();
  @Output() imprimirPedido = new EventEmitter<ImpressaoCompraSelecao>();

  readonly relatoriosImpressao = MODELOS_COMPRA.filter(relatorio => relatorio.modelo === 'PEDIDO_COMPRA');

  // ── Filtros ───────────────────────────────────────────────
  dtDe              = '';
  dtAte             = '';
  mostrarCancelados = false;
  termoBusca        = '';
  termoBuscaPn      = '';
  private _pnTimer: any = null;

  // ── Lista ─────────────────────────────────────────────────
  carregando = false;
  pedidos: PedidoCompraLinha[] = [];
  erro = '';

  // ── Paginação ─────────────────────────────────────────────
  paginaAtual    = 1;
  itensPorPagina = 11;
  readonly opcoesPorPagina = [11, 25, 50, 100];

  // ── Dropdown ações ────────────────────────────────────────
  dropdownAberto: number | null = null;

  // ── Diálogo padrão da tela (substitui alert()/confirm() nativos do navegador) ──
  dialogo: {
    tipo: 'confirmar' | 'sucesso' | 'erro' | 'aviso';
    titulo: string;
    mensagem: string;
    detalhes: string[];
    textoConfirmar: string;
    perigo: boolean;
  } | null = null;
  private dialogoResolve: ((ok: boolean) => void) | null = null;

  /** Pergunta ao usuário num modal; resolve true ao confirmar e false ao cancelar. */
  confirmar(mensagem: string, opcoes: { titulo?: string; textoConfirmar?: string; perigo?: boolean } = {}): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.dialogoResolve = resolve;
      this.dialogo = {
        tipo: 'confirmar',
        titulo: opcoes.titulo ?? 'Confirmação',
        mensagem,
        detalhes: [],
        textoConfirmar: opcoes.textoConfirmar ?? 'Confirmar',
        perigo: !!opcoes.perigo
      };
    });
  }

  /** Mostra o resultado de uma operação num modal (OK fecha). */
  informar(mensagem: string, tipo: 'sucesso' | 'erro' | 'aviso', detalhes: string[] = [], titulo?: string): Promise<void> {
    return new Promise<void>(resolve => {
      this.dialogoResolve = () => resolve();
      this.dialogo = {
        tipo,
        titulo: titulo ?? (tipo === 'sucesso' ? 'Concluído' : tipo === 'erro' ? 'Não foi possível concluir' : 'Atenção'),
        mensagem,
        detalhes,
        textoConfirmar: 'OK',
        perigo: false
      };
    });
  }

  fecharDialogo(ok: boolean): void {
    const resolve = this.dialogoResolve;
    this.dialogoResolve = null;
    this.dialogo = null;
    resolve?.(ok);
  }
  pedidoSelecionado: number | null = null;

  private empresaSub?: Subscription;

  mensagemCentral: string | null = null;
  private _mensagemCentralTimeout: ReturnType<typeof setTimeout> | null = null;

  /** Clique no PN copia o valor e mostra mensagem central por 2s. */
  copiarPn(pn: string | null | undefined, ev?: Event): void {
    ev?.stopPropagation();
    const v = String(pn ?? '').trim();
    if (!v) return;
    let ok = true;
    try {
      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(v).catch(() => {});
      } else {
        const ta = document.createElement('textarea');
        ta.value = v;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
    } catch { ok = false; }
    this.mensagemCentral = ok ? `PN copiado com sucesso: ${v}` : 'Não foi possível copiar o PN.';
    if (this._mensagemCentralTimeout) clearTimeout(this._mensagemCentralTimeout);
    this._mensagemCentralTimeout = setTimeout(() => { this.mensagemCentral = null; }, 2000);
  }

  constructor(
    private readonly gateway: SankhyaGatewayService,
    readonly empresa: EmpresaStateService
  ) {}

  ngOnInit(): void {
    const hoje = new Date();
    this.dtAte = this.toInputDate(hoje);
    const trintaDiasAtras = new Date(hoje);
    trintaDiasAtras.setDate(hoje.getDate() - 30);
    this.dtDe = this.toInputDate(trintaDiasAtras);

    this.empresaSub = this.empresa.empresaMudou.subscribe(() => this.buscar());
    this.buscar();
  }

  ngOnDestroy(): void {
    this.empresaSub?.unsubscribe();
    clearTimeout(this._pnTimer);
  }

  buscar(): void {
    // Empresa virtual (ex.: 12): CODEMP real nas notas + filtro por GPL_EMPRESA_VIRTUAL.
    const empVirtual = this.empresa.selecionadaEhVirtual ? Number(this.empresa.selecionada) : 0;
    const codEmp = empVirtual > 0 ? Number(this.empresa.codEmpReal) : Number(this.empresa.selecionada);
    if (!codEmp || !this.dtDe || !this.dtAte) return;

    this.carregando = true;
    this.erro = '';
    this.paginaAtual = 1;

    const dtDe = this.toSankhyaDate(this.dtDe);
    const dtAte = this.toSankhyaDate(this.dtAte);

    // A lista mostra os pedidos de TODAS as empresas (a coluna Empresa indica onde cada um foi gravado).
    // Pedidos NACIONAL usam a TOP 1300 e IMPORTAÇÃO a 1323: busca as duas e junta.
    // Notas de empresa VIRTUAL (ex.: 12) só vêm quando a empresa virtual é pedida explicitamente: busca cada uma também.
    const virtuais = (this.empresa.opcoes ?? []).filter((o: any) => o.virtual).map((o: any) => Number(o.codEmp)).filter((n: number) => n > 0);
    const chamadas = [1300, 1323].flatMap(top => [
      this.gateway.listarPedidosCompra(codEmp, dtDe, dtAte, this.mostrarCancelados, this.termoBuscaPn, top, true, 0, true),
      ...virtuais.map((v: number) => this.gateway.listarPedidosCompra(codEmp, dtDe, dtAte, this.mostrarCancelados, this.termoBuscaPn, top, true, v, true)),
    ]);
    forkJoin(chamadas).subscribe({
      next: (resp: any[]) => {
        const vistos = new Set<number>();
        const lista = resp.flatMap((res: any) => (res?.responseBody ?? res)?.lista ?? [])
          .filter((r: any) => { const n = Number(r.nunota ?? 0); if (vistos.has(n)) return false; vistos.add(n); return true; })
          .sort((a: any, b: any) => Number(b.nunota ?? 0) - Number(a.nunota ?? 0));
        this.pedidos = lista.map((r: any): PedidoCompraLinha => ({
          nunota:       Number(r.nunota      ?? 0),
          codemp:       Number(r.codemp      ?? 0),
          dtmov:        r.dtmov              ?? '',
          fornecedor:   r.fornecedor         ?? '',
          docparc:      r.docparc            ?? '',
          empresa:      r.empresa            ?? '',
          vlrnota:      Number(r.vlrnota     ?? 0),
          vlrmoeda:     Number(r.vlrmoeda    ?? 1),
          vlritens:     Number(r.vlritens    ?? 0),
          vlritensMoe:  Number(r.vlritensMoe ?? 0),
          vlripi:       Number(r.vlripi      ?? 0),
          vlrst:        Number(r.vlrst       ?? 0),
          vlrcoreusd:   Number(r.vlrcoreusd  ?? 0),
          status:       r.status             ?? '',
          comprador:    r.comprador          ?? '',
          tipoOperacao: r.tipoOperacao       ?? '',
          pcrIdAerosys: r.pcrIdAerosys != null && Number(r.pcrIdAerosys) > 0 ? Number(r.pcrIdAerosys) : null,
          codTipOper:   Number(r.codTipOper  ?? 0),
          observacao:   r.observacao         ?? '',
          gplStatus:    r.gplStatus          ?? '',
          numTitulo:    r.numTitulo          ?? '',
          prioridade:   r.prioridade         ?? '',
          tipoGpl:      r.tipoGpl            ?? '',
        }));
        this.carregando = false;
      },
      error: (err: any) => {
        this.erro = err?.error?.erro ?? err?.message ?? 'Erro ao buscar pedidos de compra.';
        this.carregando = false;
      }
    });
  }

  // ── Filtros reativos ──────────────────────────────────────

  // ── Ordenação por coluna (clique no cabeçalho) ──
  ordenarCampo: string | null = null;
  ordenarAsc = true;

  ordenar(campo: string): void {
    if (this.ordenarCampo === campo) {
      this.ordenarAsc = !this.ordenarAsc;
    } else {
      this.ordenarCampo = campo;
      this.ordenarAsc = true;
    }
    this.paginaAtual = 1;
  }

  private valorOrdenacao(p: PedidoCompraLinha, campo: string): number | string {
    switch (campo) {
      case 'nunota':  return Number(p.nunota) || 0;
      case 'codemp':  return Number(p.codemp) || 0;
      case 'status':  return (p.gplStatus || '').toLowerCase();
      case 'tipo':    return this.fmtTipo(p.tipoGpl).toLowerCase();
      case 'dtmov': {
        const m = String(p.dtmov || '').match(/(\d{2})\/(\d{2})\/(\d{4})(?:\D+(\d{2}):(\d{2}))?/);
        return m ? new Date(+m[3], +m[2] - 1, +m[1], +(m[4] || 0), +(m[5] || 0)).getTime() : 0;
      }
      case 'vlr':     return this.vlrTotal(p) || 0;
      case 'vlrusd':  return this.vlrTotalUsd(p) || 0;
      case 'pcrIdAerosys': return Number(p.pcrIdAerosys) || 0;
      default:        return String((p as any)[campo] ?? '').toLowerCase();
    }
  }

  get pedidosFiltrados(): PedidoCompraLinha[] {
    const lista = this.pedidosFiltradosSemOrdem;
    const campo = this.ordenarCampo;
    if (!campo) return lista;
    const dir = this.ordenarAsc ? 1 : -1;
    return [...lista].sort((a, b) => {
      const va = this.valorOrdenacao(a, campo);
      const vb = this.valorOrdenacao(b, campo);
      if (typeof va === 'number' && typeof vb === 'number') return (va - vb) * dir;
      return String(va).localeCompare(String(vb), 'pt-BR', { numeric: true }) * dir;
    });
  }

  private get pedidosFiltradosSemOrdem(): PedidoCompraLinha[] {
    const termo = this.termoBusca.trim().toLowerCase();
    if (!termo) return this.pedidos;
    return this.pedidos.filter(p =>
      String(p.nunota ?? '').includes(termo) ||
      (p.numTitulo   || '').toLowerCase().includes(termo) ||
      (p.tipoGpl     || '').toLowerCase().includes(termo) ||
      this.fmtTipo(p.tipoGpl).toLowerCase().includes(termo) ||
      (p.fornecedor  || '').toLowerCase().includes(termo) ||
      (p.docparc     || '').toLowerCase().includes(termo) ||
      (p.comprador   || '').toLowerCase().includes(termo)
    );
  }

  get totalPaginas(): number {
    return Math.max(1, Math.ceil(this.pedidosFiltrados.length / this.itensPorPagina));
  }

  get pedidosPagina(): PedidoCompraLinha[] {
    const inicio = (this.paginaAtual - 1) * this.itensPorPagina;
    return this.pedidosFiltrados.slice(inicio, inicio + this.itensPorPagina);
  }

  get paginas(): number[] {
    const total = this.totalPaginas;
    const atual = this.paginaAtual;
    const range: number[] = [];
    for (let i = Math.max(1, atual - 2); i <= Math.min(total, atual + 2); i++) {
      range.push(i);
    }
    return range;
  }

  irParaPagina(p: number): void {
    if (p < 1 || p > this.totalPaginas) return;
    this.paginaAtual = p;
  }

  onItensPorPaginaChange(): void { this.paginaAtual = 1; }
  onTermoBuscaChange(): void     { this.paginaAtual = 1; }
  onMostrarCanceladosChange(): void { this.buscar(); }

  onTermoBuscaPnChange(): void {
    clearTimeout(this._pnTimer);
    this._pnTimer = setTimeout(() => this.buscar(), 500);
  }

  selecionarLinha(event: Event, p: PedidoCompraLinha): void {
    event.stopPropagation();
    this.dropdownAberto = null;
    this.pedidoSelecionado = this.pedidoSelecionado === p.nunota ? null : p.nunota;
  }

  onImprimir(): void {
    if (this.pedidoSelecionado == null) return;
    const relatorio = this.relatoriosImpressao[0];
    if (!relatorio) return;
    this.imprimirPedido.emit({ nunota: this.pedidoSelecionado, view: relatorio.view });
  }

  // ── Cálculos de valor ─────────────────────────────────────

  /** Soma dos itens (preco de custo, sem IPI/ICMS-ST) -- igual ao total da tela do pedido. */
  vlrTotal(p: PedidoCompraLinha): number {
    return p.vlritens > 0 ? p.vlritens : (p.vlrnota || 0);
  }

  vlrTotalUsd(p: PedidoCompraLinha): number {
    if (p.vlritensMoe > 0) return p.vlritensMoe;
    const cotacao = p.vlrmoeda || 1;
    return this.vlrTotal(p) / cotacao;
  }

  fmtBrl(v: number | null | undefined): string {
    if (v == null) return '—';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v);
  }

  fmtUsd(v: number | null | undefined): string {
    if (v == null) return '—';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'USD' }).format(v);
  }

  /** GPL_TIPO (TGFCAB) -- código gravado sem acento (IMPORTACAO), exibido
   *  com o rótulo correto (IMPORTAÇÃO). */
  fmtTipo(v: string | null | undefined): string {
    if (!v) return '—';
    if (v === 'IMPORTACAO') return 'IMPORTAÇÃO';
    return v;
  }

  /** Cor do badge de Tipo (Origem) -- IMPORTACAO em lilás, NACIONAL em azul-petróleo,
   *  igual ao padrão visual do sistema legado (Aerosys). */
  tipoClass(v: string | null | undefined): string {
    const t = (v || '').toUpperCase().trim();
    if (t === 'IMPORTACAO' || t === 'IMPORTAÇÃO') return 'tipo-importacao';
    if (t === 'NACIONAL') return 'tipo-nacional';
    return 'tipo-outro';
  }

  /** Cor do badge de Status (GPL_STATUS) -- mesmo estilo visual (badge colorido)
   *  do sistema legado (Aerosys), mas usando os valores do Sankhya. COMPRADO e
   *  PARCIAL são os dois valores que faltavam no domínio GPL_STATUS (o usuário
   *  vai cadastrar no DataDictionary) -- já mapeados aqui com as mesmas cores
   *  do legado (verde/laranja) assim que existirem. */
  /** Cores do status iguais às do sistema legado. */
  statusLegadoClass(status: string | null | undefined): string {
    const s = (status || '').toUpperCase().trim();
    if (s === 'CANCELADO') return 'st-leg-cancelado';
    if (s === 'COMPRADO') return 'st-leg-comprado';
    if (s === 'AUTORIZADO') return 'st-leg-autorizado';
    if (s === 'PARCIAL') return 'st-leg-parcial';
    return 'st-leg-outro'; // ABERTO, NECESSIDADE... = sem cor
  }

  statusClass(status: string | null | undefined): string {
    const s = (status || '').toUpperCase().trim();
    switch (s) {
      case 'COMPRADO':
      case 'ENTREGUE':
      case 'FATURADO':
      case 'FINALIZADO':
      case 'PRONTO':
        return 'status-liberado';   // verde
      case 'AUTORIZADO':
      case 'ESTOQUE':
        return 'status-atendido';   // azul
      case 'ABERTO':
      case 'PENDENTE':
      case 'PARCIAL':
        return 'status-pendente';   // amarelo
      case 'CANCELADO':
      case 'ESTORNAR':
        return 'status-cancelado';  // vermelho
      case 'CONFERENCIA':
      case 'LOGISTICA':
      case 'CONTAGEM':
      case 'SEPARACAO':
      case 'SEPARACAO TOTAL':
        return 'status-processo';   // roxo
      case 'GARANTIA':
        return 'status-alerta';     // laranja
      case 'BAIXADO':
        return 'status-outro';      // cinza
      default:
        return 'status-outro';
    }
  }

  /** Código da empresa no mesmo formato do legado (0000012). */
  fmtCodEmp(codemp: number | null | undefined): string {
    if (codemp == null) return '—';
    return String(codemp);   // código da empresa no Sankhya, sem zeros à esquerda
  }

  // ── Dropdown ─────────────────────────────────────────────

  /** Item selecionado na grade, só quando a grade aberta é deste pedido. */
  private itemSelecionadoDe(p: PedidoCompraLinha): any | null {
    if (!this.itensAberto || this.itensNunota !== p.nunota || this.itemSelecionado == null) return null;
    return this.itens[this.itemSelecionado] ?? null;
  }
  /** Itens marcados (checkbox / clique na linha) da grade aberta deste pedido. */
  private itensMarcadosDe(p: PedidoCompraLinha): any[] {
    if (!this.itensAberto || this.itensNunota !== p.nunota) return [];
    return Array.from(this.itensMarcados).sort((a, b) => a - b).map(i => this.itens[i]).filter(Boolean);
  }
  /** "Cancelar item selecionado" vale para pedidos ABERTO, AUTORIZADO e PARCIAL (os demais cancelamentos seguem as regras próprias). */
  private statusPermiteCancelarSelecionados(p: PedidoCompraLinha): boolean {
    const st = this.statusNormalizado(p);
    return st === 'ABERTO' || st === 'AUTORIZADO' || st === 'PARCIAL';
  }
  private itensCancelaveisMarcados(p: PedidoCompraLinha): any[] {
    return this.itensMarcadosDe(p).filter(i => i.statusItem === 'ABERTO');
  }
  podeCancelarItemSelecionado(p: PedidoCompraLinha): boolean {
    return this.statusPermiteCancelarSelecionados(p) && this.itensCancelaveisMarcados(p).length > 0;
  }
  rotuloCancelarSelecionados(p: PedidoCompraLinha): string {
    const n = this.itensMarcadosDe(p).length;
    return n > 1 ? `Cancelar itens selecionados (${n})` : 'Cancelar item selecionado';
  }
  /** Desmembrar item: exatamente 1 item marcado, com status PARCIAL. */
  podeDesmembrarItem(p: PedidoCompraLinha): boolean {
    const m = this.itensMarcadosDe(p);
    return m.length === 1 && m[0].statusItem === 'PARCIAL';
  }
  tituloDesmembrarItem(p: PedidoCompraLinha): string {
    const m = this.itensMarcadosDe(p);
    if (m.length === 0) return 'Abra os itens do pedido e selecione um item (clique na linha ou use a caixa de seleção)';
    if (m.length > 1) return 'Selecione apenas um item para desmembrar';
    return m[0].statusItem === 'PARCIAL' ? '' : 'Só é possível desmembrar item com status PARCIAL';
  }
  async desmembrarItem(p: PedidoCompraLinha): Promise<void> {
    this.dropdownAberto = null;
    if (!this.podeDesmembrarItem(p)) return;
    const it = this.itensMarcadosDe(p)[0];
    const seq = Number(it.sequencia) || 0;
    if (seq <= 0) { await this.informar('Item sem sequência no pedido.', 'aviso'); return; }
    const qtd = Number(it.quantidade) || 0;
    if (!(await this.confirmar(
      `Desmembrar o item ${it.pn || it.codprodInterno || 'seq ' + seq} do Pedido #${p.nunota}? ` +
      `Ele será dividido em dois itens: a parte já comprada (COMPRADO) e o saldo pendente (ABERTO)` +
      (qtd > 0 ? ` — quantidade atual: ${qtd}.` : '.'),
      { titulo: 'Desmembrar item', textoConfirmar: 'Desmembrar' }))) return;
    try {
      const res: any = await firstValueFrom(this.gateway.desmembrarItemPedidoCompra(p.nunota, seq));
      if (res?.sucesso) {
        const avisos: string[] = [];
        if (res?.aerosysSyncOk === false) avisos.push('não foi possível atualizar os itens no Aerosys' + (res.aerosysSyncErro ? ': ' + res.aerosysSyncErro : ''));
        this.buscar();
        await this.informar(`Item desmembrado: ${res.qtdComprada ?? 0} comprado(s) e ${res.qtdPendente ?? 0} pendente(s) (novo item ${res.novaSequencia}).`,
          avisos.length ? 'aviso' : 'sucesso', avisos.map(a => a.charAt(0).toUpperCase() + a.slice(1) + '.'));
        if (this.itensAberto && this.itensNunota === p.nunota) {
          this.itensMarcados.clear();
          this.itemSelecionado = null;
          await this.abrirItens(new Event('click'), p, true);
        }
      } else {
        await this.informar(res?.erro ?? 'Erro desconhecido.', 'erro');
      }
    } catch (e: any) {
      await this.informar(e?.error?.erro ?? e?.message ?? 'Erro desconhecido.', 'erro');
    }
  }

  podeReabrirItens(p: PedidoCompraLinha): boolean {
    const st = this.statusNormalizado(p);
    return st === 'PARCIAL' || st === 'COMPRADO';
  }
  /** "Reabrir item selecionado" vale para pedidos ABERTO, AUTORIZADO, PARCIAL e COMPRADO. */
  private statusPermiteReabrirSelecionados(p: PedidoCompraLinha): boolean {
    const st = this.statusNormalizado(p);
    return st === 'ABERTO' || st === 'AUTORIZADO' || st === 'PARCIAL' || st === 'COMPRADO';
  }
  private itensReabriveisMarcados(p: PedidoCompraLinha): any[] {
    return this.itensMarcadosDe(p).filter(i => i.statusItem === 'CANCELADO');
  }
  podeReabrirItemSelecionado(p: PedidoCompraLinha): boolean {
    return this.statusPermiteReabrirSelecionados(p) && this.itensReabriveisMarcados(p).length > 0;
  }
  rotuloReabrirSelecionados(p: PedidoCompraLinha): string {
    const n = this.itensMarcadosDe(p).length;
    return n > 1 ? `Reabrir itens selecionados (${n})` : 'Reabrir item selecionado';
  }
  tituloCancelarItemSelecionado(p: PedidoCompraLinha): string {
    if (!this.statusPermiteCancelarSelecionados(p)) return 'Disponível apenas para pedidos ABERTO, AUTORIZADO ou PARCIAL';
    if (this.itensMarcadosDe(p).length === 0) return 'Abra os itens do pedido e selecione um ou mais itens (clique na linha ou use a caixa de seleção)';
    return this.podeCancelarItemSelecionado(p) ? '' : 'Só itens ABERTOS podem ser cancelados';
  }
  tituloReabrirItens(p: PedidoCompraLinha): string {
    return this.podeReabrirItens(p) ? '' : 'Disponível apenas para pedidos PARCIAL ou COMPRADO';
  }
  tituloReabrirItemSelecionado(p: PedidoCompraLinha): string {
    if (!this.statusPermiteReabrirSelecionados(p)) return 'Disponível apenas para pedidos ABERTO, AUTORIZADO, PARCIAL ou COMPRADO';
    if (this.itensMarcadosDe(p).length === 0) return 'Abra os itens do pedido e selecione um ou mais itens (clique na linha ou use a caixa de seleção)';
    return this.podeReabrirItemSelecionado(p) ? '' : 'Só itens CANCELADOS podem ser reabertos';
  }

  /** Executa a ação de itens, mostra o resultado e recarrega a lista (e a grade de itens, se aberta). */
  private async executarAcaoItens(p: PedidoCompraLinha, chamada: () => Promise<any>, verbo: string, campo: 'cancelados' | 'reabertos'): Promise<void> {
    try {
      const res: any = await chamada();
      if (res?.sucesso) {
        const avisos: string[] = [];
        if (res?.aerosysSyncOk === false) avisos.push('não foi possível atualizar os itens no Aerosys');
        if (res?.aerosysStatusOk === false) avisos.push('não foi possível atualizar o status do cabeçalho no Aerosys');
        if (res?.statusCabecalhoErro) avisos.push(res.statusCabecalhoErro);
        const cab = res?.statusCabecalho ? ` Cabeçalho: ${res.statusCabecalho}.` : '';
        this.buscar();
        await this.informar(`${res[campo] ?? 0} item(ns) ${verbo}.${cab}`, avisos.length ? 'aviso' : 'sucesso', avisos.map(a => a.charAt(0).toUpperCase() + a.slice(1) + '.'));
        if (this.itensAberto && this.itensNunota === p.nunota) {
          this.itensMarcados.clear();
          this.itemSelecionado = null;
          await this.abrirItens(new Event('click'), p, true);
        }
      } else {
        await this.informar(res?.erro ?? 'Erro desconhecido.', 'erro');
      }
    } catch (e: any) {
      await this.informar(e?.error?.erro ?? e?.message ?? 'Erro desconhecido.', 'erro');
    }
  }

  /** Ações > Cancelar itens em aberto: pergunta, cancela no Sankhya e no Aerosys e recarrega a lista. */
  async cancelarItensAbertos(p: PedidoCompraLinha): Promise<void> {
    this.dropdownAberto = null;
    if (!this.podeCancelarItensEmAberto(p)) return;
    if (!(await this.confirmar(`Deseja realmente cancelar TODOS os itens em aberto do Pedido #${p.nunota}?`, { titulo: 'Cancelar itens em aberto', textoConfirmar: 'Cancelar itens', perigo: true }))) return;
    await this.executarAcaoItens(p, () => firstValueFrom(this.gateway.cancelarItensAbertosPedidoCompra(p.nunota)), 'cancelado(s)', 'cancelados');
  }

  /** Ações > Cancelar item(ns) selecionado(s): só os itens ABERTOS marcados. */
  async cancelarItemSelecionado(p: PedidoCompraLinha): Promise<void> {
    this.dropdownAberto = null;
    if (!this.podeCancelarItemSelecionado(p)) return;
    const marcados = this.itensMarcadosDe(p);
    const alvo = this.itensCancelaveisMarcados(p);
    const seqs = alvo.map(i => Number(i.sequencia) || 0).filter(n => n > 0);
    if (seqs.length === 0) { await this.informar('Item sem sequência no pedido.', 'aviso'); return; }
    const ignorados = marcados.length - alvo.length;
    const quais = alvo.length === 1 ? `o item selecionado (${alvo[0].pn || alvo[0].codprodInterno || 'seq ' + seqs[0]})` : `os ${alvo.length} itens selecionados`;
    const aviso = ignorados > 0 ? ` (${ignorados} marcado(s) que não estão ABERTOS serão ignorados)` : '';
    if (!(await this.confirmar(`Deseja realmente cancelar ${quais} do Pedido #${p.nunota}?${aviso}`, { titulo: alvo.length === 1 ? 'Cancelar item' : 'Cancelar itens', textoConfirmar: alvo.length === 1 ? 'Cancelar item' : 'Cancelar itens', perigo: true }))) return;
    await this.executarAcaoItens(p, () => firstValueFrom(this.gateway.cancelarItensSelecionadosPedidoCompra(p.nunota, seqs)), 'cancelado(s)', 'cancelados');
  }

  /** Ações > Reabrir todos os itens cancelados. */
  async reabrirTodosItens(p: PedidoCompraLinha): Promise<void> {
    this.dropdownAberto = null;
    if (!this.podeReabrirItens(p)) return;
    if (!(await this.confirmar(`Deseja realmente reabrir TODOS os itens cancelados do Pedido #${p.nunota}?`, { titulo: 'Reabrir itens', textoConfirmar: 'Reabrir itens' }))) return;
    await this.executarAcaoItens(p, () => firstValueFrom(this.gateway.reabrirItensPedidoCompra(p.nunota, [])), 'reaberto(s)', 'reabertos');
  }

  /** Ações > Reabrir item(ns) selecionado(s): só os itens CANCELADOS marcados. */
  async reabrirItemSelecionado(p: PedidoCompraLinha): Promise<void> {
    this.dropdownAberto = null;
    if (!this.podeReabrirItemSelecionado(p)) return;
    const marcados = this.itensMarcadosDe(p);
    const alvo = this.itensReabriveisMarcados(p);
    const seqs = alvo.map(i => Number(i.sequencia) || 0).filter(n => n > 0);
    if (seqs.length === 0) { await this.informar('Item sem sequência no pedido.', 'aviso'); return; }
    const ignorados = marcados.length - alvo.length;
    const quais = alvo.length === 1 ? `o item selecionado (${alvo[0].pn || alvo[0].codprodInterno || 'seq ' + seqs[0]})` : `os ${alvo.length} itens selecionados`;
    const aviso = ignorados > 0 ? ` (${ignorados} marcado(s) que não estão CANCELADOS serão ignorados)` : '';
    if (!(await this.confirmar(`Deseja realmente reabrir ${quais} do Pedido #${p.nunota}?${aviso}`, { titulo: alvo.length === 1 ? 'Reabrir item' : 'Reabrir itens', textoConfirmar: alvo.length === 1 ? 'Reabrir item' : 'Reabrir itens' }))) return;
    await this.executarAcaoItens(p, () => firstValueFrom(this.gateway.reabrirItensPedidoCompra(p.nunota, seqs)), 'reaberto(s)', 'reabertos');
  }

  // ── Ações > Status (Autorizar / Cancelar / Estornar) ──
  private statusNormalizado(p: PedidoCompraLinha): string {
    const s = (p.gplStatus || '').trim().toUpperCase();
    return !s || s === 'TESTE' ? 'ABERTO' : s;   // pedidos antigos (TESTE) contam como ABERTO
  }
  /** Edição só com o pedido ABERTO (ou TESTE/vazio); nos demais status a tela abre só para visualização. */
  podeEditar(p: PedidoCompraLinha): boolean { return this.statusNormalizado(p) === 'ABERTO'; }
  podeAutorizar(p: PedidoCompraLinha): boolean { return this.statusNormalizado(p) === 'ABERTO'; }
  podeCancelarPedido(p: PedidoCompraLinha): boolean { return this.statusNormalizado(p) === 'ABERTO'; }
  /** "Cancelar itens em aberto" só vale para pedidos PARCIAL. */
  podeCancelarItensEmAberto(p: PedidoCompraLinha): boolean { return this.statusNormalizado(p) === 'PARCIAL'; }
  podeEstornar(p: PedidoCompraLinha): boolean { const st = this.statusNormalizado(p); return st === 'AUTORIZADO' || st === 'CANCELADO'; }

  async alterarStatus(p: PedidoCompraLinha, acao: 'AUTORIZAR' | 'CANCELAR' | 'ESTORNAR'): Promise<void> {
    this.dropdownAberto = null;
    const ok = acao === 'AUTORIZAR' ? this.podeAutorizar(p) : acao === 'CANCELAR' ? this.podeCancelarPedido(p) : this.podeEstornar(p);
    if (!ok) return;
    const textos = {
      AUTORIZAR: `Autorizar o Pedido #${p.nunota}? O cabeçalho ficará AUTORIZADO no Sankhya e no Aerosys.`,
      CANCELAR:  `CANCELAR o Pedido #${p.nunota}? O cabeçalho e todos os itens ficarão CANCELADOS no Sankhya e no Aerosys.`,
      ESTORNAR:  this.statusNormalizado(p) === 'CANCELADO'
        ? `Estornar o Pedido #${p.nunota}? O cabeçalho e os itens cancelados voltarão para ABERTO no Sankhya e no Aerosys.`
        : `Estornar o Pedido #${p.nunota}? Ele voltará para ABERTO no Sankhya e no Aerosys.`
    };
    const titulos = { AUTORIZAR: 'Autorizar pedido', CANCELAR: 'Cancelar pedido', ESTORNAR: 'Estornar pedido' };
    const botoes = { AUTORIZAR: 'Autorizar', CANCELAR: 'Cancelar pedido', ESTORNAR: 'Estornar' };
    if (!(await this.confirmar(textos[acao], { titulo: titulos[acao], textoConfirmar: botoes[acao], perigo: acao !== 'AUTORIZAR' }))) return;
    try {
      const res: any = await firstValueFrom(this.gateway.alterarStatusPedidoCompra(p.nunota, acao));
      if (res?.sucesso) {
        const avisos: string[] = [];
        if (res.aerosysStatusOk === false) avisos.push('não foi possível atualizar o status no Aerosys: ' + (res.aerosysStatusErro ?? ''));
        if (res.aerosysItensOk === false) avisos.push('não foi possível atualizar os itens no Aerosys');
        this.buscar();
        // Se os itens deste pedido estão abertos, recarrega (cancelar/estornar muda o status dos itens).
        if (this.itensAberto && this.itensNunota === p.nunota) {
          void this.abrirItens(new Event('refresh'), p, true);
        }
        await this.informar(`Pedido #${p.nunota} agora está ${res.statusNovo}.`, avisos.length ? 'aviso' : 'sucesso',
          avisos.map(a => a.charAt(0).toUpperCase() + a.slice(1) + (a.endsWith('.') ? '' : '.')));
      } else {
        await this.informar(res?.erro ?? 'Erro desconhecido.', 'erro', [], 'Não foi possível alterar o status');
      }
    } catch (e: any) {
      await this.informar(e?.error?.erro ?? e?.message ?? 'Erro desconhecido.', 'erro', [], 'Não foi possível alterar o status');
    }
  }

  toggleDropdown(event: Event, p: PedidoCompraLinha): void {
    event.stopPropagation();
    this.dropdownAberto = this.dropdownAberto === p.nunota ? null : p.nunota;
  }

  /** Duplo clique na linha abre o pedido em edição -- mesmo padrão do
   *  Pedido de Venda (onDblClickLinha em pedido-venda-lista.component.ts).
   *  Não checa status aqui: a própria tela de edição decide se abre travada
   *  (só leitura) ou editável, conforme o GPL_STATUS do pedido. */
  onDblClickLinha(p: PedidoCompraLinha): void {
    this.editarPedido.emit(p.nunota);
  }

  // ── Itens do pedido (clique no Código) ─────────────────────
  // Mesmos campos do lançamento de itens do Pedido de Compra (pedido-compra-form).
  itensAberto = false;
  itensCarregando = false;
  itensErro = '';
  itensNunota: number | null = null;
  itens: any[] = [];
  itemSelecionado: number | null = null;

  /** Itens marcados para as ações em lote (cancelar...): clique na linha ou na caixa alterna a marcação. */
  itensMarcados = new Set<number>();

  selecionarItem(i: number, event: Event): void {
    event.stopPropagation();
    if (this.itensMarcados.has(i)) this.itensMarcados.delete(i); else this.itensMarcados.add(i);
    // itemSelecionado = último marcado (usado pelas ações de um item só, como a previsão de entrega)
    this.itemSelecionado = this.itensMarcados.size ? Array.from(this.itensMarcados).pop()! : null;
  }

  get todosItensMarcados(): boolean {
    return this.itens.length > 0 && this.itensMarcados.size === this.itens.length;
  }

  toggleTodosItens(event: Event): void {
    event.stopPropagation();
    if (this.todosItensMarcados) {
      this.itensMarcados.clear();
      this.itemSelecionado = null;
    } else {
      this.itens.forEach((_, i) => this.itensMarcados.add(i));
      this.itemSelecionado = this.itens.length ? this.itens.length - 1 : null;
    }
  }

  fmtDec(v: number | null | undefined): string {
    if (v == null) return '—';
    return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v);
  }

  private dataAnalitico(deslocMeses: number): string {
    const d = new Date();
    d.setMonth(d.getMonth() + deslocMeses);
    return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
  }

  /** recarregar=true: atualiza os itens já abertos sem fechar/limpar o painel (evita o "pulo" da tela). */
  async abrirItens(event: Event, p: PedidoCompraLinha, recarregar = false): Promise<void> {
    event.stopPropagation();
    this.dropdownAberto = null;
    if (!recarregar && this.itensAberto && this.itensNunota === p.nunota) { this.fecharItens(); return; }
    let tipoGplDetalhe = '';
    const itensAnteriores = recarregar ? this.itens : [];
    this.itensNunota = p.nunota;
    this.itensAberto = true;
    if (!recarregar) {
      this.itensCarregando = true;
      this.itensErro = '';
      this.itens = [];
      this.itemSelecionado = null;
      this.itensMarcados.clear();
    }
    try {
      const res: any = await firstValueFrom(this.gateway.buscarDetalhesPedidoVenda(p.nunota));
      const body = res?.responseBody ?? res;
      const d = body?.sucesso ? (body.detalhe ?? body) : null;
      const brutos: any[] = d?.itens ?? [];
      tipoGplDetalhe = String(d?.tipoGpl ?? '').trim();
      if (!d || brutos.length === 0) {
        this.itensErro = d ? '' : 'Pedido não encontrado.';
        return;
      }
      const novosItens = brutos.map((it: any) => {
        const st = String(it.statusItem || '').toUpperCase();
        const qtd = Number(it.qtd ?? it.qtdneg) || 0;
        // Custo = Preço do Fabricante, igual ao form: U$ (vlrunitmoe) e R$ (vlrunit) gravados no pedido.
        const custoUsd = Number(it.precoUsd) || Number(it.vlrunitmoe) || 0;
        const custoBrl = Number(it.vlrunit) || 0;
        return {
          codprodInterno: Number(it.codprod) || 0,
          pn: it.refforn ?? it.referencia ?? String(it.codprod ?? ''),
          descricao: it.descricao ?? '',
          unidade: it.codvol ?? 'UN',
          quantidade: qtd,
          fabricante: '',
          custoUsd,
          custoBrl,
          totalUsd: Number(it.vlrtotmoe) || parseFloat((custoUsd * qtd).toFixed(2)),
          totalBrl: Number(it.vlrtot) || parseFloat((custoBrl * qtd).toFixed(2)),
          obs: String(it.obsItem ?? ''),
          statusItem: ['ABERTO', 'CANCELADO', 'COMPRADO', 'PARCIAL'].includes(st) ? st : 'ABERTO',
          sequencia: Number(it.seq) || 0,
          previsaoEntrega: String(it.previsaoEntrega ?? ''),
          estoque: null, cd: '', custo: null, qtdeVendas: null, qtdeVendasAnoAnt: null,
          pontoPedido: null, qtdePedidoOutros: null, pedidoOutros: '',
          qtdePrecompraAbBk: null, dataPrecompraAbBk: '', estoqueEua: null,
        };
      });
      if (recarregar) {
        // Mantém as colunas de apoio já carregadas (estoque etc.) até o refresh em segundo plano: sem "piscar".
        for (const n of novosItens as any[]) {
          const ant: any = itensAnteriores.find((a: any) => a.sequencia === n.sequencia && a.codprodInterno === n.codprodInterno);
          if (ant) {
            for (const c of ['fabricante', 'estoque', 'cd', 'custo', 'qtdeVendas', 'qtdeVendasAnoAnt', 'pontoPedido',
              'qtdePedidoOutros', 'pedidoOutros', 'qtdePrecompraAbBk', 'dataPrecompraAbBk', 'estoqueEua']) {
              n[c] = ant[c];
            }
          }
        }
      }
      this.itens = novosItens;
    } catch (err: any) {
      this.itensErro = err?.message ?? 'Erro ao buscar os itens do pedido.';
      return;
    } finally {
      this.itensCarregando = false;
    }

    // Colunas de apoio (estoque + Aerosys) carregam em segundo plano, como no lançamento.
    const nunota = p.nunota;
    const itensAtuais = this.itens;
    const codemp = Number(p.codemp) || Number(this.empresa.selecionada) || 0;
    const tipo = (tipoGplDetalhe || p.tipoGpl || '').toUpperCase().trim();
    const empresaAerosys = tipo === 'NACIONAL' ? 1 : 12;
    const codProds = Array.from(new Set(itensAtuais.map(i => i.codprodInterno).filter((c: number) => c > 0)));

    itensAtuais.forEach(async (item: any) => {
      if (!item.codprodInterno) return;
      try {
        const r: any = await firstValueFrom(this.gateway.buscarEstoquePorLocal(item.codprodInterno));
        const lista: any[] = (r?.responseBody ?? r)?.locais ?? [];
        let total = 0;
        for (const loc of lista) {
          const emp = parseInt(String(loc.codemp ?? '0'), 10);
          if (codemp > 0 && emp !== codemp) continue;
          total += parseFloat(String(loc.disponivel ?? '0').replace(',', '.')) || 0;
        }
        item.estoque = parseFloat(total.toFixed(3));
      } catch { /* ignora */ }
    });

    if (codProds.length > 0 && codemp > 0) {
      const aplicar = async (empAero: number): Promise<boolean> => {
        const r: any = await firstValueFrom(this.gateway.buscarAnaliticoItensPedidoCompra(
          codProds, codemp, empAero, this.dataAnalitico(-3), this.dataAnalitico(0)));
        const linhas: any[] = Array.isArray(r) ? r : (r?.itens ?? []);
        const porCod = new Map<number, any>();
        for (const l of linhas) if (l?.codProd != null) porCod.set(Number(l.codProd), l);
        if (this.itensNunota !== nunota) return true;
        let achouAerosys = false;
        for (const item of itensAtuais) {
          const dd = porCod.get(item.codprodInterno);
          if (!dd) continue;
          if (dd.cd != null || dd.custo != null || dd.estoqueEua != null) achouAerosys = true;
          item.cd = dd.cd ?? '';
          item.fabricante = dd.fabricante ?? '';
          item.custo = dd.custo ?? null;
          item.pontoPedido = dd.pontoPedido ?? null;
          item.estoqueEua = dd.estoqueEua ?? null;
          item.qtdeVendas = dd.qtdeVendas ?? null;
          item.qtdeVendasAnoAnt = dd.qtdeVendasAnoAnt ?? null;
          item.qtdePedidoOutros = dd.qtdePedidoOutros ?? null;
          item.pedidoOutros = dd.pedidoOutros ?? '';
          item.qtdePrecompraAbBk = dd.qtdePrecompraAbBk ?? null;
          item.dataPrecompraAbBk = dd.dataPrecompraAbBk ?? '';
        }
        return achouAerosys;
      };
      try {
        // Se o Aerosys nao devolveu nada pra empresa deduzida pelo tipo, tenta a outra.
        if (!(await aplicar(empresaAerosys))) await aplicar(empresaAerosys === 1 ? 12 : 1);
      } catch { /* painel de apoio: falha nao trava a lista */ }
    }
  }

  fecharItens(): void { this.itensAberto = false; }

  fecharDropdown(): void { this.dropdownAberto = null; this.funcoesMenuAberto = false; }

  // ── Botão Funções do cabeçalho ──
  funcoesMenuAberto = false;

  // ── Exportar (Excel / CSV / Área de Transferência) -- mesmo padrão da Lista de Parceiros ──
  avisoFuncoes = '';
  avisoErro = false;
  private timerAviso: any = null;

  private mostrarAviso(msg: string, erro = false): void {
    this.avisoFuncoes = msg;
    this.avisoErro = erro;
    if (this.timerAviso) clearTimeout(this.timerAviso);
    this.timerAviso = setTimeout(() => (this.avisoFuncoes = ''), 4000);
  }

  private readonly colunasExport = ['Código', 'Status', 'Nº Título', 'Prioridade', 'Empresa', 'Tipo', 'Solicitação',
    'Solicitante', 'Observação', 'CNPJ', 'Fornecedor', 'Valor R$', 'Valor U$', 'Nº Ped. Aerosys'];

  /** Todos os pedidos do filtro atual (todas as páginas), com as mesmas colunas e formatos da grade. */
  private linhasExport(): string[][] {
    return this.pedidosFiltrados.map(p => [
      String(p.nunota ?? ''),
      p.gplStatus || '',
      p.numTitulo || '',
      p.prioridade || '',
      this.fmtCodEmp(p.codemp),
      this.fmtTipo(p.tipoGpl),
      p.dtmov || '',
      p.comprador || '',
      p.observacao || '',
      p.docparc || '',
      p.fornecedor || '',
      this.fmtBrl(this.vlrTotal(p)),
      this.fmtUsd(this.vlrTotalUsd(p)),
      p.pcrIdAerosys != null ? String(p.pcrIdAerosys) : ''
    ]);
  }

  private nomeArquivoExport(ext: string): string {
    const d = new Date();
    const p = (n: number) => String(n).padStart(2, '0');
    return `pedidos_compra_${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}_${p(d.getHours())}${p(d.getMinutes())}.${ext}`;
  }

  private baixarArquivo(blob: Blob, nome: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = nome;
    a.click();
    URL.revokeObjectURL(url);
  }

  private executarExport(acao: (linhas: string[][]) => Promise<string> | string): void {
    this.funcoesMenuAberto = false;
    const linhas = this.linhasExport();
    if (linhas.length === 0) { this.mostrarAviso('Não há pedidos na lista para exportar.', true); return; }
    Promise.resolve()
      .then(() => acao(linhas))
      .then(msg => this.mostrarAviso(msg))
      .catch((err: any) => this.mostrarAviso(err?.message ?? 'Erro ao exportar os dados.', true));
  }

  exportarExcel(): void {
    this.executarExport(linhas => {
      const ws = XLSX.utils.aoa_to_sheet([this.colunasExport, ...linhas]);
      ws['!cols'] = this.colunasExport.map((_, i) => ({ wch: i === 8 || i === 10 ? 40 : 16 }));
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Pedidos de Compra');
      XLSX.writeFile(wb, this.nomeArquivoExport('xlsx'));
      return `${linhas.length} pedido(s) exportado(s) para Excel.`;
    });
  }

  exportarCsv(): void {
    this.executarExport(linhas => {
      const fmt = (v: string): string => (/[;"\n\r]/.test(v) ? '"' + v.replace(/"/g, '""') + '"' : v);
      const csv = [this.colunasExport, ...linhas].map(l => l.map(fmt).join(';')).join('\r\n');
      this.baixarArquivo(new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' }), this.nomeArquivoExport('csv'));
      return `${linhas.length} pedido(s) exportado(s) para CSV.`;
    });
  }

  copiarParaAreaDeTransferencia(): void {
    this.executarExport(async linhas => {
      const texto = [this.colunasExport, ...linhas]
        .map(l => l.map(v => String(v ?? '').replace(/[\t\r\n]+/g, ' ')).join('\t')).join('\r\n');
      await navigator.clipboard.writeText(texto);
      return `Dados copiados para a área de transferência com sucesso! (${linhas.length} pedido(s))`;
    });
  }

  /** Opções do menu Funções -- as telas/regras de cada uma serão desenvolvidas na próxima etapa. */
  gerarPedidosAbaixoPontoPedido(comVendas: boolean): void {
    this.funcoesMenuAberto = false;
    void comVendas;
  }

  toggleFuncoesMenu(event?: Event): void {
    event?.stopPropagation();
    this.funcoesMenuAberto = !this.funcoesMenuAberto;
  }

  // ── Utilitários de data ──────────────────────────────────

  private toInputDate(d: Date): string {
    return d.toISOString().substring(0, 10);
  }

  private toSankhyaDate(iso: string): string {
    const [y, m, dia] = iso.split('-');
    return `${dia}/${m}/${y}`;
  }
}
